import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { BookOpen, Dumbbell, ListChecks, LineChart, GraduationCap } from 'lucide-react';
const deliverables = [{
  icon: BookOpen,
  title: 'Guía Principal "Memoria Blindada" (PDF)',
  desc: 'El manual paso a paso para entender y potenciar su cerebro.'
}, {
  icon: Dumbbell,
  title: 'Cuaderno de Gimnasia Neuronal',
  desc: '15 minutos diarios de ejercicios prácticos de fluidez y retención.'
}, {
  icon: ListChecks,
  title: 'El Checklist de "Casa a Prueba de Olvidos"',
  desc: 'Trucos ambientales para no volver a perder objetos.'
}, {
  icon: LineChart,
  title: 'Diario de Logros Cognitivos',
  desc: 'Para medir cómo su velocidad mental aumenta semana tras semana.'
}, {
  icon: GraduationCap,
  title: 'Glosario de Empoderamiento',
  desc: 'Para entender su salud mental sin términos médicos complicados.'
}];
export function WhatYouGet() {
  return <section className="bg-cream-50 py-24 md:py-32 px-6" data-id="element-178">
      <div className="max-w-5xl mx-auto" data-id="element-179">
        <FadeIn data-id="element-180">
          <div className="text-center mb-16" data-id="element-181">
            <h2 className="font-serif text-3xl md:text-4xl text-navy-900 font-bold mb-4" data-id="element-182">
              Lo que recibe hoy
            </h2>
            <div className="w-16 h-1 bg-gold-400 mx-auto rounded-full" data-id="element-183"></div>
          </div>
        </FadeIn>

        <div className="grid gap-6 md:gap-8" data-id="element-184">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-185">
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-all border border-cream-200 flex flex-col md:flex-row items-start md:items-center gap-6 group" data-id="element-186">
                <div className="bg-cream-100 p-4 rounded-xl group-hover:bg-gold-50 transition-colors shrink-0" data-id="element-187">
                  <item.icon className="w-8 h-8 text-gold-600" data-id="element-188" />
                </div>
                <div data-id="element-189">
                  <h3 className="text-xl md:text-2xl font-bold text-navy-900 mb-2" data-id="element-190">
                    {item.title}
                  </h3>
                  <p className="text-lg text-charcoal-700" data-id="element-191">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}